/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Edit_Approve_FailedInputs */

const en_samples_edit_approve_failed = /** @type {(inputs: Samples_Edit_Approve_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to approve sample`)
};

const es_samples_edit_approve_failed = /** @type {(inputs: Samples_Edit_Approve_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al aprobar muestra`)
};

/**
* | output |
* | --- |
* | "Failed to approve sample" |
*
* @param {Samples_Edit_Approve_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_edit_approve_failed = /** @type {((inputs?: Samples_Edit_Approve_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Edit_Approve_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_edit_approve_failed(inputs)
	return es_samples_edit_approve_failed(inputs)
});